module.exports = __webpack_public_path__ + "img/img11.7659686d.jpg";